import { IfStmt } from '@angular/compiler';
import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
// @ts-ignore
import ApexCharts from 'apexcharts';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EmsdashboardService } from '../services/emsdashboard.service';
import { TransformerManagerService } from '../services/transformerManager.service';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material'
import { DeviceMasterService } from '../services/device-master.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { DatePipe } from '@angular/common'; // Import the DatePipe
import { EmsalerttabledialogComponent } from '../emsalerttabledialog/emsalerttabledialog.component';
import { AlertpopuptableComponent } from '../alertpopuptable/alertpopuptable.component';
import { PopuptableComponent } from '../popuptable/popuptable.component';
import { EmspopuptableComponent } from './emspopuptable/emspopuptable.component'; 
@Component({
  selector: 'app-ems',
  templateUrl: './ems.component.html',
  styleUrls: ['./ems.component.scss'],
  animations: [
    trigger('blinkAnimation', [
      state('visible', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('visible <=> hidden', animate('0.5s'))
    ])
  ]
})
export class EmsComponent implements OnInit {








  @ViewChild('energyconsumption_graph', { static: true }) energyconsumption_graph: ElementRef;
  @ViewChild('consumption_graph_m', { static: true }) consumption_graph_m: ElementRef;
  @ViewChild('consumption_graph_mb', { static: true }) consumption_graph_mb: ElementRef;
  @ViewChild('chart1', { static: true }) loadchart: ElementRef;
  @ViewChild('chart2', { static: true }) mdchart: ElementRef;
  @ViewChild('chart3', { static: true }) pfchart: ElementRef;
  @ViewChild('chart4', { static: true }) currentchart: ElementRef;
  @ViewChild('bill', { static: true }) kwhbill: ElementRef;
  @ViewChild('unit', { static: true }) kwhunit: ElementRef;
  @ViewChild('fbill', { static: true }) fkwhbill: ElementRef;
  @ViewChild('funit', { static: true }) fkwhunit: ElementRef;
  @ViewChild('monthwiseConsumption', { static: true }) monthWiseConsumption: ElementRef;
  @ViewChild('daywiseConsumption', { static: true }) daywiseConsumption: ElementRef;
  @ViewChild('minutewiseConsumption', { static: true }) minutewiseConsumption: ElementRef;

  qwerty = 9;
  myData: any = [];
  energymeterIdsArray = [];
  AllEnergyMeterMonthData = [];
  alertCounts: any;
  harmonics: any = 0;
  voltageHigh: any = 0;
  voltageLow: any = 0;
  overload: any = 0;
  lowPowerFactor: any = 0;
  allAlertSectiondata;
  communicationFailure: any;

  public annotaions: object;
  avgpfd: any = 0.0;
  allalertdata;
  KWHValue: any;
  speakerOn: boolean = true;
  muteSuggestions: boolean = false;
  showLoader: boolean = true;
  isMain: boolean = true;
 bgToggle:boolean = true;
  logavgpf: any = 0;
  toggleSpeaker() {
    this.speakerOn = !this.speakerOn;
    this.muteSuggestions = !this.speakerOn;
  }
  pfValue;
  labelStyles = {
    position: 'Inside',
    format: '{value}',
    offset: 4,
    color: 'red',
    width: 2
  };
  kwhData = 1953790.85;
  cost;
  color = "green";
  energyMeterId = [];
  selectedEnergyMeter;
  AllEnergyMeterData;
  recentGraphDiv;
  latestkwh_p;
  blinkState = 'visible';
  rangeStart1: number = -1;
  rangeEnd1: number = 1;
  lengtho = 0;
  averagepf;
  skVAh;
  pf;
  pfm;
  energyMeterSum: any = {};
  cuser;
  showInfo: string = 'first';
  latestDate;
  uniqueDeviceId;
  Deviceid;
  monthDiv;
  averagePfS;
  meterIdAveragePfArray: any = [];
  energyconsumption;
  dayDiv;
  minuteDiv;
  animationRunning = true;
  animationRunnings = true;
  totalkwhcurrentmonth: any = 0;
  selectedDevice;
  energyMeterIdArray;
  energyMeterSumArray;
  resettotalkwh;
  meterCountValue;
  digits: number[];
  digitsc: number[];
  sortedData: any[];
  totalKvah: any = 0;
  currentUserData = JSON.parse(localStorage.getItem('userData'));
  LiveAlertsArray = [];
  dialogRefas: MatDialogRef<EmsalerttabledialogComponent, any>;
  allmetersid: any = {};
  searchname:string='';
  totalMeters: number = 0;
  onlineMeters: number = 0;
  offlineMeters: number = 0;
  normalMeters: number = 0;
  alertMeters: number = 0;
  mainmeter;
  allmeterstatusdata: any = {};
  meteridDesc:any ;
  alldataofmonth;
  searchQuery: string = '';

  ngAfterViewInit() {
    
    this.monthDiv = this.monthWiseConsumption;
    this.energyconsumption = this.energyconsumption_graph;
    this.dayDiv = this.daywiseConsumption;
    this.minuteDiv = this.minutewiseConsumption;

  }

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(private matDialog: MatDialog, private dialog: MatDialog, private ngxLoader: NgxUiLoaderService, private datePipe: DatePipe, private renderer: Renderer2, private EmsdashboardService: EmsdashboardService, private deviceManagerSer: DeviceMasterService, private transMngSer: TransformerManagerService) { }
 ngOnInit() {
  this.ngxLoader.startLoader('emsDashboard');
    this.getEnergymetrId();

 
    /*  ** OLD Code **
    this.blink(this.alertCountGraph);
    this.ngxLoader.startLoader('emsDashboard');
      */

  }


//***********************************CODES *******************************//


getEnergymetrId() {
  let user_id = this.currentUserData.userid;
  let roleid = this.currentUserData.roleid;

  this.EmsdashboardService.getEnergyMeterIds({ "userid": user_id, "roleid": roleid }).subscribe(async (response: any) => {
      this.meteridDesc=response;
      this.allmetersid = await response.data.map((meter: any) => meter.meterSerialNumber);
      const mainMeters = response.data.filter((meter: any) => meter.meterType === "Main");
      
      // If no main meter found, use allmetersid instead
      this.mainmeter = mainMeters.length > 0
          ? mainMeters.map((meter: any) => meter.meterSerialNumber)
          : this.allmetersid;
          if(mainMeters.length == 0 ){
            this.isMain = false;
            this.searchname="Search by Meter ID";
          }else
          {
             this.searchname="Search by Main Meter ID"
          }
      // this.dayWiseConsumptionGraph(this.mainmeter);
      // this.MonthwiseAveragekwh(this.mainmeter); // check (only main meter kwh)
      this.getmonthdatameterwise(this.allmetersid)
      this.checkStatusOfMters(this.allmetersid);            // all Meter status
      //this.getAllEnergyMeterMonthData(this.allmetersid);    // for Energy Consumption
      this.MonthwiseAveragepf(this.mainmeter);              // for avgpf
      this.hourlyWiseConsumptionGraph(this.mainmeter);      // Hourly kwh
      this.getAlertsData();                                 // live alert
      this.alertSection(this.allmetersid);                  // Parameter alert
  
      
  });
}



getmonthdatameterwise(meters: any) {
  this.EmsdashboardService.getemsmonthdata({ "meterid": meters }).subscribe(async (response: any) => {
    const responseData = response && response.data ? response.data : [];
    const meterDescData = this.meteridDesc && this.meteridDesc.data ? this.meteridDesc.data : [];
    const combinedResults = responseData.map(item => {
      const pfavg = item.count != 0 ? (Number(item.avgpf) / item.count).toFixed(2) : 0;
      const matchingDesc = meterDescData.find(desc => desc.meterSerialNumber === item.meterid);
      return {
        ...item,
        description: matchingDesc ? matchingDesc.assetName : `No description found for meterid: ${item.meterid}`,
        type: matchingDesc ? matchingDesc.meterType : `No meter type found for meterid: ${item.meterid}`, // Add meterType here
        pfavg:pfavg
      };
    });
    this.alldataofmonth=combinedResults;
    this.alldataofmonth.sort((a,b) => {
      const idA = a.meterid;
      const idB = b.meterid;
      if (idA < idB) return -1;
      if (idA > idB) return 1;
      return 0;
    });

    let totalMonthKwh = 0;
    let totalMonthKvah = 0;
    let testdata = 0;
    let totalLogKwh = 0;
    let mainMeterMonthKwh = 0;
    let mainMeterMonthKvah = 0;
    let totalKwh = 0;
    let totalKvah = 0;
    let totalavgpf:any = 0;
    let foundMainMeter = false;
for (const meter of this.alldataofmonth) {
  
  if (meter.type == "Main") {
    totalKwh = Number(meter.logsystemkwh); 
    totalKvah = Number(meter.logsystemkvah);
    mainMeterMonthKwh += Number(meter.kwh);
    mainMeterMonthKvah += Number(meter.kvah);
    totalavgpf = Number(meter.logavgpf)
    foundMainMeter = true; 
  } else {
    totalMonthKwh += Number(meter.kwh); 
    totalMonthKvah += Number(meter.kvah); 
  }
}
console.log("Number(meter.kwh).toFixed(2)",totalMonthKwh)

if (!foundMainMeter) {
  totalKwh = 0;
  totalKvah = 0;
  totalavgpf = "NO DATA";
}
this.latestkwh_p = totalKwh;
this.totalKvah= totalKvah;
this.logavgpf = totalavgpf;
this.energyBalanceGraph(Number(mainMeterMonthKwh).toFixed(2),Number(totalMonthKwh.toFixed(2)),Number(mainMeterMonthKvah).toFixed(2),Number(totalMonthKvah).toFixed(2))
  });
}
filterData() {
  if (!this.searchQuery) {
    return this.alldataofmonth;
  }
  const query = this.searchQuery.toLowerCase();
  return this.alldataofmonth.filter(subMeter =>
    subMeter.meterid.toLowerCase().includes(query) ||
    subMeter.description.toLowerCase().includes(query)
  );
}
checkStatusOfMters(meters: string[]) {
  this.EmsdashboardService.meterStatus({ "meterid": meters }).subscribe(async (response: any) => {
    const meterData = Array.isArray(response.data) ? response.data : response;
    this.allmeterstatusdata = meterData;
    this.totalMeters = meterData.length;
    this.onlineMeters = 0;
    this.offlineMeters = 0;
    this.normalMeters = 0;
    this.alertMeters = 0;
    meterData.forEach((meter: any) => {
      const { status, alertStatus } = meter;
      if (status === "Online") {
        this.onlineMeters++;
        if (alertStatus === "No Alert") {
          this.normalMeters++;
        }
      } else if (status === "Offline") {
        this.offlineMeters++;
      }

      if (alertStatus === "Alert Generated") {
        this.alertMeters++;
      }
    });
  });
}

hourlyWiseConsumptionGraph(meterArray) {
  let YesterdaysData = [];
  let data = [];
  let time = [];
  const today = new Date();
  var date = new Date(today.getFullYear(), today.getMonth(), 1);
  var days = [];

  this.EmsdashboardService.getCurrentAndPreviousDaysKwhData({ "meterArray": meterArray }).subscribe((response: any) => {

    if (response.result[0].length > 0 || response.result[1].length > 0) {
      response.result[0].forEach(row => {
        data.push(parseFloat(Number(row.kwhdata).toFixed(2)));  
        time.push(row.hour);
      });
      response.result[1].forEach(data => {
        YesterdaysData.push(parseFloat(Number(data.kwhdata).toFixed(2)));
      });
    } else {
      data.push(0);
      YesterdaysData.push(0);
    }
    while (date.getMonth() === today.getMonth()) {
      days.push(new Date(date).getUTCDate());
      date.setDate(date.getDate() + 1);
    }

    const options = {
      colors: ['#0B84A5', '#F6C85F'],
     
      series: [
        { name: "Yesterday", data: YesterdaysData },
        { name: "Today", data: data }
      ],
      chart: {
        height: '100%',
        width: '100%',
        type: 'area',
        toolbar: {
          show: true,
          tools: { download: true, selection: true, zoom: false },
          style: {
            fontFamily: 'Arial, sans-serif',
            fontSize: '1.5vh',
            fontWeight: 'bold',
            color: '#000000',
            background: 'transparent',
          },
        },
      },
      title: {
        text: "Hourly KWH", 
        align: 'center', 
        style: {
          fontSize: '2vh',
          align: 'center', 
          fontWeight: 'bold', 
          color: '#ffffff' 
        },
        margin: 20,
      },
      grid: { show: false },
      legend: { position: 'top', labels: { useSeriesColors: true } },
      dataLabels: { enabled: false },
      stroke: { curve: 'smooth' },
      yaxis: {
        title: {
          text: "KWH",
          style: { fontSize: '1.5vh', color: "white", fontWeight: 'bold' },
        },
        labels: { style: { fontSize: '1.5vh', colors: '#FFFFFF', fontWeight: 'bold' } }
      },
      xaxis: {
        type: 'category',
        categories: time,
        labels: {
          style: { fontSize: '1.5vh', colors: '#FFFFFF', fontWeight: 'bold',background: 'white', },
        },
      },
      tooltip: {
        shared: true,
      intersect: false,
        theme: 'dark',
        style: {
          backgroundColor: '#333',
        },
      },
      
    };

    var chart = new ApexCharts(this.minuteDiv.nativeElement, options);
    chart.render();
    this.ngxLoader.stopLoader('emsDashboard');
  });
}

alertSection(meters: string[]) {
  this.EmsdashboardService.alertSections({ meterid: meters }).subscribe((response: any) => {
    if (response.code === 1 && response.data.length > 0) {
      this.allAlertSectiondata = response.data;
      response.data.forEach((alert: any) => {
        switch (alert.parametername) {
          case 'apLowPowerfactor':
            this.lowPowerFactor++;
            break;
          case 'communicationFailure':
            this.communicationFailure++;
            break;
          case 'overloadAlert':
            this.overload++;
            break;
          case 'lowVoltage':
            this.voltageLow++;
            break;
          case 'highVoltage':
            this.voltageHigh++;
            break;
          case 'harmonics':
            this.harmonics++;
            break;
        }
      });
    }
  });
}

popupTablealert(state, selected) {
  console.log("asdsadasd",selected);
  if(selected > 0){
  const dialogConfig = new MatDialogConfig();
  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = true;
  dialogConfig.height = '80%';
  dialogConfig.width = '70%';
  if (this.totalMeters !== undefined) {
    dialogConfig.data = {
      type: state,
      alldata: this.allAlertSectiondata,
      show: false

    };
    if (selected == "alertDataSelected") {
      dialogConfig.data['selected'] = selected;
    }
    if (selected == "helathCenterDataSelected") {
      dialogConfig.data['selected'] = selected;
    }
    let dialogRef = this.matDialog.open(EmspopuptableComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((response) => {
    })
  }
}
}

MonthwiseAveragepf(meterArray) {
  let user_id = this.currentUserData.userid;
  this.EmsdashboardService.getMonthwiseAveragePF({ "meterArray": meterArray }).subscribe((response: any) => {
    var data = response.result;
    if (data.length > 0) {
      this.avgpfd = data[response.result.length - 1].avgpf.toFixed(2);
      this.SuggestionsTileData();
      var avgPfValues = data.map(item => item.avgpf);
      var months = data.map(item => item.month);
      var options = {
        series: [
          {
            name: "Average PF",
            data: avgPfValues
          },
        ],
        chart: {
          type: "bar",
          color: "white",
          height: '100%',
      
          animations: {
            speed: 500
          }
        },
        title: {
          text: "Monthwise Average PF",
          align: 'center',  
          style: {
            fontSize: '2vh',
            fontWeight: 'bold', 
            color: '#ffffff' 
          },
          margin: 20,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "40%"
          }
        },
        dataLabels: {
          enabled: false,
          dropShadow: {
            blur: 3,
            opacity: 0.8
          }
        },
        stroke: {
          curve: "straight",
          width: 2
        },
        legend: {
          show: true,
          inverseOrder: true,
          labels: {
            useSeriesColors: true
          },
          markers: {
            hover: {
              sizeOffset: 5
            }
          }
        },
        colors: ['#ff8c00'],
        yaxis: {
          title: {
            text: "PF",
            style: {
              fontSize: '1.5vh', 
              color: '#FFFFFF',
              fontWeight: 'bold'
            }
          },
          labels: {
            style: {
              fontSize: '1.5vh',
              colors: '#FFFFFF',
              fontWeight: 'bold',
            },
            formatter: function (value) {
              return value.toFixed(2);
            }
          }
        },
        xaxis: {
          categories: months.map(month => {
            var monthNames = [
              "Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];
            return monthNames[month - 1];
          }),
          labels: {
            style: {
              padding: "1%", 
              fontSize: '1.5vh', 
              colors: '#FFFFFF',
              fontWeight: 'bold'
            }
          }
        },
        grid: {
          show: false  
        },
        markers: {
          hover: {
            sizeOffset: 5
          }
        }
      };
      
      var chart = new ApexCharts(this.consumption_graph_mb.nativeElement, options);
      chart.render()
      this.ngxLoader.stopLoader('emsDashboard');
    } else {
      this.ngxLoader.stopLoader('emsDashboard');
    }
  });
}

energyBalanceGraph(Mainkwh,subKwh,mainKvah,subKvah){
  var options = {
    series: [
      {
        name: 'Main Meter',
        data: [Mainkwh, mainKvah]
      },
      {
        name: 'Sub Meters',
        data: [subKwh, subKvah]
      }
    ],
    chart: {
      type: 'bar',
      height: "100%"
    },
    plotOptions: {
      bar: {
        horizontal: false, 
      }
    },
    legend: { position: 'top', labels: { useSeriesColors: true } },
    dataLabels: {
      enabled: true,
      offsetY: -20, 
      style: {
        fontSize: '1.5vh',
        colors: ['#fff']
      }
    },
    stroke: {
      show: true,
      width: 1,
      colors: ['#fff']
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (val, opts) {
          return `${val}`;
        }
      }
    },
    xaxis: {
      categories: ["Kwh", "Kvah"],
      labels: {
        style: {
          fontSize: '1.5vh',
          colors: '#FFFFFF',
          fontWeight: 'bold',
        },
      }
    },
    yaxis:{
      title: {
        text: "consumption",
        style: {
          fontSize: '1.5vh', 
          color: '#FFFFFF',
        }
      },
      labels: {
        style: {
          fontSize: '1.5vh',
          colors: '#FFFFFF',
          fontWeight: 'bold',
        },
      }
    },
    grid: {
      show: false 
    }
  };
  
  
  var chart = new ApexCharts(document.querySelector("#energyBalance"), options);
  chart.render();
}

alertCountGraph(){
  var options = {
    series: [44, 55, 41, 17, 15],
    chart: {
    height: "100%",
    type: 'donut',
  },
  plotOptions: {
    pie: {
      startAngle: -90,
      endAngle: 270
    }
  },
  dataLabels: {
    enabled: false
  },
  fill: {
    type: 'gradient',
  },
  legend: {
    formatter: function(val, opts) {
      return val + " - " + opts.w.globals.series[opts.seriesIndex]
    }
  },
  title: {
    text: 'Device Conncetion Status'
  },
  responsive: [{
    breakpoint: 480,
    options: {
      chart: {
        width: 200
      },
      legend: {
        position: 'bottom'
      }
    }
  }]
  };

  var chart = new ApexCharts(document.querySelector("#alertsGraph"), options);
  chart.render();
}
popupTable(state, selected) {
  const dialogConfig = new MatDialogConfig();
  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = true;
  dialogConfig.height = '80%';
  dialogConfig.width = '70%';
  if (this.totalMeters !== undefined) {
    dialogConfig.data = {
      type: state,
      allstatus: this.allmeterstatusdata,
      show: true
    };
    if (selected == "alertDataSelected") {
      dialogConfig.data['selected'] = selected;
    }
    if (selected == "helathCenterDataSelected") {
      dialogConfig.data['selected'] = selected;
    }
    let dialogRef = this.matDialog.open(EmspopuptableComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((response) => {
    })
  }
}

getAlertsData() {
  let user_id = this.currentUserData.userid;
  this.EmsdashboardService.getLastUpdatedAlert({ "userid": user_id }).subscribe((response: any) => {
    if (response.result.length > 0) {
      console.log("alertdata",response.result)
      this.LiveAlertsArray = response.result;
    }
  })
}

SuggestionsTileData() {
  if (this.avgpfd < 0.9) {
    return "Low Lagging Power Factor (PF < 0.9)";
  } else if (this.avgpfd >= 1) {
    return "High Leading Power Factor (PF > 1 or close to 1)";
  } else {
    return "Power Factor is within an acceptable range.";
  }
}

getPowerFactorSuggestion() {
  var lowMeterIds = [];
  var highMeterIds = [];
  for (const meterData of this.AllEnergyMeterMonthData) {
    if (meterData.avgpf < 0.9) {
      lowMeterIds.push(meterData.energyMeterId + '(' + meterData.assetName + ')');
    } else if (meterData.averagePf > 1) {
      highMeterIds.push(meterData.energyMeterId + '(' + meterData.assetName + ')');
    }
  }

  const suggestions = [];
  if (lowMeterIds.length > 0) {
    const meterListLow = lowMeterIds.join(', ');
    suggestions.push(`Energy meters ${meterListLow} have low average power factor.
  Consider improving power factor for better efficiency.`);
  }
  if (highMeterIds.length > 0) {
    const meterListHigh = highMeterIds.join(', ');
    suggestions.push(`Energy meters ${meterListHigh} have high average power factor.
  Investigate and analyze any capacitive loads or equipment connected to the system that might be contributing to the leading power factor.`);
  }

  if (suggestions.length > 0) {
    return suggestions.join('\n\n');
  } else {
    return "Power Factor is within an acceptable range.";
  }
}

openTodayAlertsModal() {
  const dialogConfig = new MatDialogConfig();

  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = true;
  dialogConfig.height = '90%';
  dialogConfig.width = '90%';
  dialogConfig.data = {
    type: "AlertsTable",
    currentUserData: this.currentUserData,
  };
  this.dialogRefas = this.dialog.open(EmsalerttabledialogComponent, dialogConfig);
}

blink() {
  this.blinkState = 'hidden';
  setTimeout(() => {
    this.blinkState = 'visible';
    this.blink();
  }, 500);
}

stopAnimations(): void {
  this.animationRunnings = false;
  const alertsLists = document.getElementById('suggestion-list');
  if (alertsLists) {
    alertsLists.classList.remove('suggestionlists');
  }
}

startAnimations(): void {
  this.animationRunnings = true;
  const alertsLists = document.getElementById('suggestion-list');
  if (alertsLists) {
    alertsLists.classList.add('suggestionlists');
  }
}

toggleBackground(){
  let div = document.getElementById('change');
  let icon = document.getElementById('icon');
  if(this.bgToggle){ 
    div.style.backgroundColor = "white";
    icon.className = "fas fa-sun";       
    icon.style.color = "orange"; 
    this.bgToggle = false;
  } else {
    div.style.backgroundColor = "black";
    icon.className = "fas fa-moon";      
    icon.style.color = "yellow";
    this.bgToggle = true;
  }
}
  



  // **************************OLD CODE *********************************************** //





  MonthwiseAveragekwh(meterArray) {
    let user_id = this.currentUserData.userid;
    console.log("meterArray", meterArray)
    console.log("main meterArray", this.mainmeter)
    this.EmsdashboardService.getMonthwiseConsumptionData({ "meterArray": meterArray }).subscribe((response: any) => {
      var data = response.result;
      console.log("response.result", response)
      console.log("data", data)
      let categories = [];
      let consumptionData = [];
      data.forEach(row => {
        categories.push(row.month)
        consumptionData.push(Number(row.total_kwh).toFixed(2))
      });
      var prvve = ["0", "0"]

      var months = {
        1: "Jan",
        2: "Feb",
        3: "Mar",
        4: "Apr",
        5: "May",
        6: "Jun",
        7: "Jul",
        8: "Aug",
        9: "Sept",
        10: "Oct",
        11: "Nov",
        12: "Dec"
      };

      var monthLabels = categories.map(function (month) {
        return months[month];
      });

      var options = {
        tooltip: {
          theme: 'dark',
          style: {
            backgroundColor: '#333',
            color: '#fff'
          }
        },
        chart: {

          height: '100%',
          width: '100%',
          type: "bar",
          toolbar: {
            show: true
          }
        },
        grid: {
          show: false,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          }
        },
        legend: {
          position: 'top',
          labels: {
            useSeriesColors: true
          },
        },
        title: {
          text: "Monthly KWH",
          style: {
            color: "black" 
          }
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 1,
          colors: ["black"]
        },
        series: [
          {
            name: "Current Year",
            data: consumptionData,
          },
          {
            name: "Previous Year",
            data: prvve,
          }
        ],
        colors: ['#0B84A5', '#F6C85F'],
        yaxis: {
          show: true,
          title: {
            text: "KWH",
            rotate: -90,
            offsetX: 0,
            offsetY: 0,
            style: {
              fontSize: '12px', 
              color: "black", 
              fontWeight: 'bold',
            }
          },
          labels: {
            style: {
              fontSize: '12px', 
              color: "black", 
              fontWeight: 'bold',
            }
          },
        },
        xaxis: {
          show: true,
          categories: monthLabels,
          labels: {
            style: {
              fontSize: '12px', 
              color: "black", 
              fontWeight: 'bold',
            }
          },
          tickPlacement: 'between',

        },
        responsive: [{
          breakpoint: 768,
          options: {
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '100%',
                endingShape: 'rounded'
              }
            },
            legend: {
              position: 'bottom',
            }
          }
        }]
      };

      var chart = new ApexCharts(this.monthDiv.nativeElement, options);
      chart.render();
    });
  }

  

  dayWiseConsumptionGraph(meterArray) {
    let prvMonthData = [];
    let data = [];
    let day = [];
    const today = new Date()
    var date = new Date(today.getFullYear(), today.getMonth(), 1);
    var days = [];
    let user_id = this.currentUserData.userid;
    this.EmsdashboardService.getCurrentAndPreviousMonthsKwhData({ "meterArray": ['E230005'] }).subscribe((response: any) => {
      if (response.result[0].length > 0 || response.result[1].length > 0) {
        response.result[0].forEach(row => {
          data.push(Number(row.kwh).toFixed(2));
          day.push(row.day);
        })
        response.result[1].forEach(data => {
          prvMonthData.push(Number(data.kwh).toFixed(2));
        });
      } else {
        data.push(0);
        prvMonthData.push(0);
      }

      var options = {
        tooltip: {
          theme: 'dark', // Use a dark theme for the tooltip
          style: {
            backgroundColor: '#333', // Change the tooltip background color
            // Change the tooltip text color
          }
        },
        series: [{
          name: 'Last Month',
          data: prvMonthData
        }, {
          name: 'Current Month',
          data: data
        }],
        chart: {

          height: '100%',
          width: '100%',
          type: 'area',
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              customIcons: []
            },
            export: {
              csv: {
                filename: "Consumption",
                columnDelimiter: ',',
                headerCategory: 'category',
                headerValue: 'value',
                dateFormatter(timestamp) {
                  return new Date(timestamp).toDateString()
                }
              },
              svg: {
                filename: "Consumption",
              },
              png: {
                filename: "Consumption",
              }
            },
            autoSelected: 'zoom',
            container: {
              height: '40px', // Set the height of the toolbar
              style: {
                background: '#000',
                fill: "black" // Set the background color of the toolbar
              }
            },

            item: {
              color: '#fff', // Set the color of the toolbar text
              fontSize: '12px', // Set the font size of the toolbar text
            },
          },

        },
        grid: {
          show: false,

        },
        colors: ['#0B84A5', '#F6C85F'],
        legend: {
          position: 'top',
          labels: {

            useSeriesColors: true
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        yaxis: {
          title: {
            text: "KWH",
            rotate: -90,
            offsetX: 0,
            offsetY: 0,
            style: {
              fontSize: '12px', // Adjust font size
              color: "black", // Set the label color to white
              fontWeight: 'bold',
            }
          },
          labels: {
            style: {
              fontSize: '12px', // Adjust font size
              color: "black", // Set the label color to white
              fontWeight: 'bold',
            }

          },
        },
        xaxis: {
          type: 'number',
          categories: day,
          tickAmount: 15,
          tickPlacement: 'between',
          labels: {
            show: true,
            rotate: 0,
            style: {
              fontSize: '12px', // Adjust font size
              color: "black", // Set the label color to white
              fontWeight: 'bold'
            }
          },
        },
        title: {
          text: "Daily KWH",
          style: {
            color: "black" // Set the label color to white
          }
        },
      };
      var chart = new ApexCharts(this.dayDiv.nativeElement, options);
      chart.render();

    });
  }

  

  getAllEnergyMeterMonthData(meterArray) {
    let user_id = this.currentUserData.userid;
    this.EmsdashboardService.getTotalMonthlyData({ "meterArray": meterArray }).subscribe((response: any) => {
      if (response.result[1].length > 0) {
        this.AllEnergyMeterMonthData = response.result[0];

        this.AllEnergyMeterMonthData.sort((a, b) => {
          const idA = a.energyMeterId;
          const idB = b.energyMeterId;

          if (idA < idB) return -1;
          if (idA > idB) return 1;
          return 0;
        });

        this.totalKvah = 0; 

        for (let i = 0; i < this.AllEnergyMeterMonthData.length; i++) {
          this.totalKvah += Number(this.AllEnergyMeterMonthData[i].monthsystemkvah);

          const matchedMeter = response.result[1].find(meter => meter.meterSerialNumber === this.AllEnergyMeterMonthData[i].energyMeterId);
          if (matchedMeter) {
            this.AllEnergyMeterMonthData[i].assetName = matchedMeter.assetDescription;
            this.AllEnergyMeterMonthData[i].type = matchedMeter.meterType;
          } else {
            this.AllEnergyMeterMonthData[i].assetName = "Unknown Asset"; // Adjust as necessary
          }
        }

        this.totalKvah = Number(this.totalKvah).toFixed(2);
       }

    });
  }

  
  

  fetchLatestEMSAlertData() {

    this.EmsdashboardService.getLiveEMSAlertsData({ userid: this.currentUserData.userid, roleid: this.currentUserData.roleid }).subscribe((response: any) => {
      if (this.LiveAlertsArray.length > 0) {
        if (this.LiveAlertsArray[this.LiveAlertsArray.length - 1].id != response.result.id) {
          this.LiveAlertsArray.push(response.result);
          if (this.dialogRefas && this.dialogRefas.componentInstance) {
            this.dialogRefas.componentInstance.data.newData = response.result;
          }
        }
      } else {
        this.LiveAlertsArray.push(response.result);
      }
    });
  }
}
